<div class="w-full flex flex-col">
	@if (submitted_() && form()?.hasError('duplicateEmails')) {
		<div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
			<div class="flex items-center">
				<ui-icon name="warning" class="text-red-500 mr-2" size="sm" />
				<span class="text-sm text-red-700 font-medium">
					Duplicate email addresses detected. Each recipient must have a unique
					email address.
				</span>
			</div>
		</div>
	}
	<ul class="w-full flex flex-col list-none divide-y divide-gray-200">
		@for (recipient of recipients(); track recipient.id) {
			<app-e-signing-recipient-list-item
				[formControl]="form().get(recipient.id)"
				[submitted_]="submitted_()"
				[recipientName]="recipient.name"
				[recipientInitials]="recipient.initials"
				[avatarVariant]="
					AVATAR_VARIANT_ORDER[$index % AVATAR_VARIANT_ORDER.length]
				"
			/>
		}
	</ul>
</div>
